import { render, staticRenderFns } from "./teams.vue?vue&type=template&id=936b0700&scoped=true&"
import script from "./teams.vue?vue&type=script&lang=js&"
export * from "./teams.vue?vue&type=script&lang=js&"
import style0 from "./teams.vue?vue&type=style&index=0&id=936b0700&scoped=true&lang=css&"
import style1 from "./teams.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936b0700",
  null
  
)

export default component.exports